class ImageProcessor {
  constructor () {
    this.MAX_THUMBNAIL_WIDTH = 150
    this.MAX_THUMBNAIL_HEIGHT = 150
  }

  async process (file) {
    throw new Error('Not Implemented')
  }
}

export default ImageProcessor
